export const SKINS = {
  DESIGNED_COLUMN: 'wysiwyg.viewer.skins.column.DesignedColumn',
  DESIGNED_STRIP_CONTAINER: 'wysiwyg.viewer.skins.stripContainer.DesignedStrip',
  DEFAULT_STRIP_COLUMN_CONTAINER:
    'wysiwyg.viewer.skins.stripContainer.DefaultStripColumnContainer',
};
